import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { GRAPH_ENDPOINT_PROFILE_IMAGE } from '../../../utility/constant-config';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {

  constructor(private http: HttpClient) {}

  getProfileImage() {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${localStorage.getItem('bearer_token')}`
      });
  
      return this.http.get(`${GRAPH_ENDPOINT_PROFILE_IMAGE}`, { responseType: 'blob', headers })
    }
}
